/**
 * Whether the sights key is held or tapped.
 *
 * Writes to [verbHoldModes](../../../core/input/verbHoldModes.ts), which every control map reads
 * per tick. The latch itself is `verbLatches.ts`, above the simulation, so the change reaches the
 * game without anything below the control map learning that a setting exists.
 *
 * The knob most likely to be moved. Holding the right button for the length of a firefight is the
 * default because it is what a shooter's muscle memory expects, and it is also the one demand this
 * game makes of a hand that may not want to make it.
 */

import { choiceApply } from '@/ui/settings/controls/choiceButtons';
import { DEFAULT_HOLD_MODE, setHoldMode } from '@/core/input/verbHoldModes';
import { HOLD_MODE_CHOICE } from '@/ui/settings/holdModeOptions';
import { SETTING_AIM_HOLD_LABEL, SETTING_AIM_HOLD_HINT } from '@/text/settingsText';
import type { SettingDefinition } from '@/ui/settings/settingContract';

export const AIM_HOLD_MODE: SettingDefinition = {
  id: 'aimHoldMode',
  section: 'controls',
  label: SETTING_AIM_HOLD_LABEL,
  hint: SETTING_AIM_HOLD_HINT,
  control: HOLD_MODE_CHOICE,
  defaultValue: DEFAULT_HOLD_MODE,
  apply: choiceApply((value: string): void => {
    setHoldMode('aim', value);
  }),
};
